import { render, staticRenderFns } from "./Proforma.vue?vue&type=template&id=33eb41a6"
import script from "./Proforma.vue?vue&type=script&lang=js"
export * from "./Proforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports